import { render, staticRenderFns } from "./MWCCarouselView.vue?vue&type=template&id=ea4ffed6&scoped=true&"
import script from "./MWCCarouselView.vue?vue&type=script&lang=js&"
export * from "./MWCCarouselView.vue?vue&type=script&lang=js&"
import style0 from "./MWCCarouselView.vue?vue&type=style&index=0&id=ea4ffed6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4ffed6",
  null
  
)

export default component.exports